import { useMemo } from "react";

import TableCellText from "ds/components/Table/Row/CellText";

import useCellCopyAction from "../../useCellCopyAction";
import IntentProjectEnvironmentMountedFilesTableCell from "../Cell";
import { IntentProjectEnvironmentMountedFilesTableCellContentProps } from "../types";

const IntentProjectEnvironmentMountedFilesTableNameCell = ({
  item: variable,
  ...cellProps
}: IntentProjectEnvironmentMountedFilesTableCellContentProps) => {
  const copyAction = useCellCopyAction({
    text: variable.id,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <IntentProjectEnvironmentMountedFilesTableCell
      {...cellProps}
      role="rowheader"
      actions={actions}
    >
      <TableCellText>{variable.id}</TableCellText>
    </IntentProjectEnvironmentMountedFilesTableCell>
  );
};

export default IntentProjectEnvironmentMountedFilesTableNameCell;
